import flagKeys from '@/constants/flagKeys';
import SocialMediaTemplatesPostsList from '@/views/MarketingCenter/SocialMediaTemplates/PostsList/PostsList.vue';
import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';

const socialMediaAssets = new Route(
  '/marketing-center/social-media-templates',
  'marketingCenter',
  SocialMediaTemplatesPostsList,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: 'marketing-center',
    navbar: {
      name: 'Social Media Assets', // TODO apply i18n
      icon: 'social-rewards',
      description:
        'Use these tools to create appealing posts to promote your offers & Loyalty Rewards.'
    },
    pageView: {
      eventLabel: 'Social Media Assets'
    },
    feature: {
      type: IBusinessType.BOTH
    }
  }
);

export { socialMediaAssets };
export default socialMediaAssets;
